// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { deleteProductFamilies } from "./schema/delete-product-families";
import { getProductCatalog } from "./schema/get-product-catalog";
import { streamListingFieldOptimization } from "./schema/product-catalog/stream-listing-field-optimization";
import { getProductTaxonomy } from "./schema/product-taxonomy-finder/get-product-taxonomy";
import { searchProductTaxonomy } from "./schema/product-taxonomy-finder/search-product-taxonomy";
import { publishProductFamilies } from "./schema/publish-product-families";
import { getRecommendedPurchaseOrders } from "./schema/purchase-orders/get-recommended-purchase-orders";
import { unpublishProductFamilies } from "./schema/unpublish-product-families";

export const groupH: {
  streamListingFieldOptimization: typeof streamListingFieldOptimization;
  deleteProductFamilies: typeof deleteProductFamilies;
  publishProductFamilies: typeof publishProductFamilies;
  unpublishProductFamilies: typeof unpublishProductFamilies;
  getProductCatalog: typeof getProductCatalog;
  getProductTaxonomy: typeof getProductTaxonomy;
  searchProductTaxonomy: typeof searchProductTaxonomy;
  getRecommendedPurchaseOrders: typeof getRecommendedPurchaseOrders;
} = {
  streamListingFieldOptimization,
  deleteProductFamilies,
  publishProductFamilies,
  unpublishProductFamilies,
  getProductCatalog,
  getProductTaxonomy,
  searchProductTaxonomy,
  getRecommendedPurchaseOrders,
};
